export var OutcomeAttributionType;
(function (OutcomeAttributionType) {
    OutcomeAttributionType[OutcomeAttributionType["Direct"] = 1] = "Direct";
    OutcomeAttributionType[OutcomeAttributionType["Indirect"] = 2] = "Indirect";
    OutcomeAttributionType[OutcomeAttributionType["Unattributed"] = 3] = "Unattributed";
    OutcomeAttributionType[OutcomeAttributionType["NotSupported"] = 4] = "NotSupported";
})(OutcomeAttributionType || (OutcomeAttributionType = {}));
//# sourceMappingURL=Outcomes.js.map